// extracted by mini-css-extract-plugin
module.exports = {"mine":"MobileLayout_mine__bKSck"};